import { Text } from '@mantine/core';
import { DateFormat, FORMAT_DATE } from 'constant/format';
import dayjs from 'dayjs';
import id from 'dayjs/locale/id';
import en from 'dayjs/locale/en';
import React from 'react';

interface DatesProps {
  date: string | string[];
  type?: 'range' | 'default';
  locale?: 'id' | 'en';
  dateFormat?: DateFormat;
  fz?: number;
  fw?: number;
  c?: string;
}
const Dates: React.FC<DatesProps> = ({
  date,
  c,
  fz = 14,
  fw = 500,
  type = 'default',
  locale = 'en',
  dateFormat = 'dateName'
}) => {
  if (type === 'range' && Array.isArray(date)) {
    if (!date[0] && !date[1])
      return (
        <Text c={c} fz={fz} fw={fw}>
          -
        </Text>
      );
    return (
      <Text c={c} fz={fz} fw={fw} component='div'>
        {date[0] &&
          dayjs(date[0])
            .locale(locale === 'id' ? id : en)
            .format(FORMAT_DATE[dateFormat])}
        {date[0] && date[1] && <span> - </span>}
        {date[1] &&
          dayjs(date[1])
            .locale(locale === 'id' ? id : en)
            .format(FORMAT_DATE[dateFormat])}
      </Text>
    );
  }

  if (typeof date === 'string' && date !== '') {
    return (
      <Text c={c} fz={fz} fw={fw}>
        {dayjs(date)
          .locale(locale === 'id' ? id : en)
          .format(FORMAT_DATE[dateFormat])}
      </Text>
    );
  }

  return (
    <Text c={c} fz={fz} fw={fw}>
      -
    </Text>
  );
};

export default Dates;
